/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2023
 * @format
 * @flow
 */

import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Typography,
  Box,
} from '@material-ui/core';
import useStyles from './useStyles';
import strings from "../../globalization";

const CustomDialog = (props) => {
  const {
    type,
    heading,
    message,
    buttons,
  } = props;

  if (type === 'popup') {
    return (
      <AlertDialog
        heading={heading}
        message={message}
        buttons={buttons}
      />
    );
  } else if (type === 'spinner') {
    return (
      <SpinnerDialog
        heading={heading}
        message={message}
        buttons={buttons}
      />
    );
  } else {
    return null;
  }
};

export default CustomDialog;

const AlertDialog = ({
  heading,
  message,
  buttons,
}) => {
  let errorMsg = strings.errorPopupDefaultMessage;
  let supportMsg = "", errorConfMsg = "";
  if (typeof message === 'object' || message instanceof Object) {
    const { errorMessage, supportMessage, message: errMsg, errorConfirmationMsg } = message;
    errorMsg = errMsg || errorMessage || strings.errorPopupDefaultMessage;
    supportMsg = supportMessage;
    errorConfMsg = errorConfirmationMsg;
  } else if (typeof message === 'string') {
    errorMsg = message;
  }

  return (
    <Dialog
      open={true}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      PaperProps={{
        style: {
          maxHeight: '40%',
          maxWidth: '40%',
        }
      }}
    >
      <DialogTitle id="dialog-title">{heading}</DialogTitle>
      <DialogContent>
        {errorConfMsg && (
          <Typography variant='body1' color='error' align='center'>{errorConfMsg}</Typography>
        )}
        <Typography variant='body1' align='center'>{errorMsg}</Typography>
        {supportMsg && (
          <Typography variant='body2' align='center'>{supportMsg}</Typography>
        )}
      </DialogContent>
      {buttons && Array.isArray(buttons) && (
        <DialogActions>
          {buttons.map(button =>
            <Button key={`key-${button.text}`} onClick={button.onClick} color="primary" variant='text'>
              {button.text}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

const SpinnerDialog = ({
  heading,
  message,
  buttons,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      open={true}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      PaperProps={{
        style: {
          minWidth: '40%',
        }
      }}
    >
      <DialogContent className={classes.dialogContent}>
        <CircularProgress className={classes.circularProgress} />
        <Box marginLeft={3}>
          <Typography variant='h5' color='textPrimary' className={classes.heading}>{heading}</Typography>
          <Typography variant='body1' color='textSecondary'>{message}</Typography>
        </Box>
      </DialogContent>
      {buttons && Array.isArray(buttons) && (
        <DialogActions>
          {buttons.map(button =>
            <Button key={`key-${button.text}`} onClick={button.onClick} color="primary" variant='text'>
              {button.text}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

